import type { Components } from '@mui/material/styles';

export default function MuiListItemButton(): Components['MuiListItemButton'] {
  return {};
}
